import React, { useState } from 'react'

import { Container, Row, Col, Image } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import Paper from 'components/atoms/Paper'
import TmvnCarousel from 'components/molecules/TmvnCarousel'

const reasons = [
  {
    id: 1,
    text: '“Biaya hidup efisien dan cukup terjangkau. ”',
    imgSrc: '/assets/img/kit-landing/cambodia/living-cost-in-cambodia-biaya-hidup-di-kamboja-quipper-campus.jpg',
    imgAlt: 'Biaya Hidup di Kamboja | Quipper Campus',
  },
  {
    id: 2,
    text: '“Lokasi geografis dan historis yang hampir sama dengan negara kita, membuatmu mudah untuk beradaptasi.”',
    imgSrc: '/assets/img/kit-landing/cambodia/cambodia-nature-and-geography-geografi-kamboja-quipper-campus.jpg',
    imgAlt: 'Pemandangan Alam dan Geografi Kamboja | Quipper Campus',
  },
  {
    id: 3,
    text: '“Kamu akan mendapatkan pengalaman belajar yang berbeda dan berkualitas, mulai dari kurikulum, media, dan metode pengajaran.”',
    imgSrc: '/assets/img/kit-landing/cambodia/kit-cambodia-working-prospect-quipper-campus.jpg',
    imgAlt: 'Prospek Kerja KIT Cambodia | Quipper Campus',
  },
  {
    id: 4,
    text: '"Tingkat persaingan relatif kecil, sehingga peluangmu untuk mendapatkannya semakin besar."',
    imgSrc: '/assets/img/kit-landing/cambodia/student-competition-kit-cambodia-quipper-campus.jpg',
    imgAlt: 'Persaingan Kuliah di KIT Cambodia | Quipper Campus',
  },
]

const textNodes = reasons.map((reason, idx) => (
  <Typography component="h3" variant="subheading" className="text-center why-cambodia__reason" key={`txt-nd-${idx}`}>
    {reason.text}
  </Typography>
))

const imgNodes = reasons.map((reason, idx) => (
  <Image
    className="img-responsive"
    alt={reason.imgAlt}
    src={reason.imgSrc}
    key={`why-cmd-img-${idx}`}
  />
))

const WhyCambodia = () => {
  const [activeItm, setActiveItm] = useState(0)

  return (
    <div id="why-cambodia" className="why-cambodia">
      <Container>
        <Typography component="h2" variant="title" className="why-cambodia__title text-center">
          Kenapa Kamboja?
        </Typography>
        <Row>
          <Col md="8 col-md-offset-2">
            <Typography component="p" variant="body" className="why-cambodia__content text-center">
              Ada banyak alasan kenapa kamu harus mempertimbangkan Kamboja sebagai negara tujuan studi kamu selanjutnya, Quipperian. Inilah beberapa di antaranya:
            </Typography>
          </Col>
        </Row>
        <Paper className="why-cambodia__gallery" rounded>
          <Row className="d-flex a-i-stretch">
            <Col md="6">
              <TmvnCarousel
                id="why-cambodia-imgs"
                indicators={false}
                activeItm={activeItm}
                items={imgNodes}
                controlled
              />
            </Col>
            <Col md="6">
              <TmvnCarousel
                id="why-cambodia-crsl"
                items={textNodes}
                activeItm={activeItm}
                autoInterval={3000}
                sideEffect={idx => setActiveItm(idx)}
              />
            </Col>
          </Row>
        </Paper>
      </Container>
    </div>
  )
}

export default WhyCambodia
